<div class="p-fluid p-formgrid p-grid">
  <div class="p-col-12 p-lg-3">
    <p-card header="Filtros" (keyup)="ds.onEnterPesquisar($event)">
      <div class="p-fluid">
        <m-restricao-number label="Id" [restricao]="ds.restricoes.atributo('id')"></m-restricao-number>
        <m-restricao-string label="Nome" [restricao]="ds.restricoes.atributo('nome')"></m-restricao-string>
      </div>
      <p-footer>
        <div class="p-grid p-fluid">
          <div class="p-field p-col">
            <button pButton label="Pesquisar" (click)="ds.pesquisar()"></button>
          </div>
          <div class="p-field p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="ds.limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>

  <div class="p-col-12 p-lg-9">
    <p-card header="Lista de jurisdições">
      <p-table
        [value]="ds.entidades"
        [totalRecords]="ds.total"
        (onLazyLoad)="ds.carregar($event)"
        [lazy]="true"
        [(rows)]="ds.registros"
        [paginator]="true"
        responsive="true"
        sortMode="multiple"
        styleClass="p-datatable-striped"
        responsiveLayout="scroll"
        emptyMessage="Nenhum registro encontrado">

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="id" style="width: 80px">Id <p-sortIcon field="id"></p-sortIcon></th>
            <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
            <th pSortableColumn="orgaoJustica">Orgão Justiça <p-sortIcon field="orgaoJustica"></p-sortIcon></th>
            <th style="width: 80px" class="p-text-center">Ação</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-entity>
          <tr>
            <td class="p-text-center" style="width: 8rem;">{{entity.id}}</td>
            <td>{{entity.nome}}</td>
            <td>{{entity.orgaoJustica.nome}}</td>
            <td class="p-text-center">
             <a
                pButton [routerLink]="['/jurisdicao/visualizar/', entity.id]"
                class="p-button-sm p-m-r-2"
                icon="pi pi-search"
                pTooltip="Visualizar">
              </a>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-text-right">
              Quantidade de registros: <span class="p-text-bold">{{ds.total}}</span>
            </div>
          </div>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>
